import { useCallback, useEffect, useState } from "react";
import { execService } from "@/services";
import { apiErrorMessage } from "@/lib/api";
import { toast } from "sonner";
import { HeartPulse, Loader2 } from "lucide-react";
import { useTenantScope, TenantPicker, SelectTenantNotice, PageHeader, Distribution } from "./shared";

export default function CustomerHealthOverview() {
  const scope = useTenantScope();
  const { isSuper, tenantId, params } = scope;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const blocked = isSuper && !tenantId;

  const load = useCallback(() => {
    if (blocked) { setData(null); return; }
    setLoading(true);
    execService.customerHealth(params).then(setData).catch((e) => toast.error(apiErrorMessage(e.response?.data?.detail))).finally(() => setLoading(false));
  }, [blocked, params]);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="exec-customer-health-page">
      <PageHeader icon={HeartPulse} title="Customer Health Overview" subtitle="Health distribution and lifecycle across the customer base.">
        <TenantPicker {...scope} />
      </PageHeader>

      {blocked ? <SelectTenantNotice /> : loading && !data ? (
        <div className="flex items-center justify-center py-20 text-muted-foreground"><Loader2 className="h-6 w-6 animate-spin" /></div>
      ) : data ? (
        <div className="space-y-4">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            <div className="bg-card border border-border rounded-xl p-4" data-testid="health-total"><p className="text-xs text-muted-foreground uppercase">Total Customers</p><p className="text-2xl font-bold text-foreground mt-1">{data.total}</p></div>
            <div className="bg-card border border-border rounded-xl p-4" data-testid="health-atrisk"><p className="text-xs text-muted-foreground uppercase">At-Risk</p><p className="text-2xl font-bold text-red-600 mt-1">{data.atRisk}</p></div>
            <div className="bg-card border border-border rounded-xl p-4" data-testid="health-bands"><p className="text-xs text-muted-foreground uppercase">Health Bands</p><p className="text-2xl font-bold text-foreground mt-1">{Object.keys(data.byBand || {}).length}</p></div>
          </div>
          <div className="grid lg:grid-cols-2 gap-4">
            <Distribution title="By health band" data={data.byBand} testid="health-by-band" />
            <Distribution title="By lifecycle stage" data={data.byStage} testid="health-by-stage" />
          </div>
        </div>
      ) : null}
    </div>
  );
}
